import React from 'react'

import SelectField from './SelectField'

// Lets the donor pick which fundraiser project their donation supports
// when the goal_partner_item has more than one project configured. When
// no project is preselected upstream, the first option is a "choose a
// project" prompt (empty value) and the user must pick before continuing.
const ProjectSelect = ({
  i18n, projectId, setProjectId, projects, prompt, error,
}) => (
  <SelectField
    id="project-designation"
    label={i18n.t('project_designation')}
    error={error}
    value={projectId}
    onChange={e => setProjectId(e.target.value)}
  >
    {prompt && (
      <option value="">{i18n.t('project_designation_prompt')}</option>
    )}
    {projects.map(project => (
      <option key={project.id} value={project.id}>
        {project.name}
      </option>
    ))}
  </SelectField>
)

export default ProjectSelect
